import { useMutation } from "@tanstack/react-query";
import { DeletePermissionFormData } from "../schema/DeletePermissionSchema";
import { privateApi } from "../../../api/api";
import { AxiosResponse } from "axios";
import { DeletePermissionResponseSchema } from "../response/DeletePermissionResponse";
import { ErrorResponse } from "../response/ErrorResponse";

export const useDeletePermission = () => {
    return useMutation({
        mutationKey: ['permission', 'delete'],
        mutationFn: async (formData: DeletePermissionFormData) => privateApi.delete(`/v3/permission/${formData.id}`),
        onSuccess: async (response: AxiosResponse) => {
            const validationResult = DeletePermissionResponseSchema.safeParse(response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid permission data format");
            }

            return validationResult.data;
        },
        onError: (error) => {
            const validationResult = ErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid permission data format");
            } else {
                console.error(`Failed to delete permission`, error);
                throw error;
            }
        }
    })
}